<script>
  import AccordionGroup from "../Components/Accordion/AccordionGroup.svelte";
  import AccordionItem from "../Components/Accordion/AccordionItem.svelte";

  export let title, parentId;
</script>

<AccordionGroup {title} {parentId}>
  <AccordionItem>
    <div slot="header">
      Is there an additional cost to renew my registration online?
    </div>
    <div slot="content">
      There is no additional charge to use STAR to renew your vehicle
      registration.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      Can I use my receipt as proof of current registration until I receive my
      decal(s) in the mail?
    </div>
    <div slot="content">
      Yes, your receipt can be used as proof of current registration until you
      receive your decal(s) in the mail.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">Can I make a partial payment?</div>
    <div slot="content">No, amount due must be paid in full.</div>
  </AccordionItem>
</AccordionGroup>
